import { Component, EventEmitter, Input, Output } from '@angular/core'

import { BaseComponent } from 'common/helpers'
import { MediaRootDetail } from 'elements-sdk/src'

import { SubtitlesClipboardService } from '../services/subtitlesClipboard.service'

@Component({
  selector: 'subtitles-clipboard',
  templateUrl: './subtitlesClipboard.component.pug',
})
export class SubtitlesClipboardComponent extends BaseComponent {
  @Input() drawerVisible = false
  @Input() root: MediaRootDetail
  @Output() open = new EventEmitter<void>()

  constructor (public subtitlesClipboard: SubtitlesClipboardService) {
    super()
  }

  toggle () {
    this.drawerVisible = !this.drawerVisible
    if (this.drawerVisible) {
      this.open.emit()
    }
  }
}
